export default __webpack_public_path__ + "static/media/logoPurple.4261a31e.png";